import { Grid, Paper, Typography } from "@mui/material";
import React from "react";
import CardHeaderTitle from "../../components/card-header-title/index.jsx";
import IncreaseDecreaseArrows from "../../components/increase-decrease-arrows/index.js";
import { roundNumberHelper } from "../../helpers/index.js";

const ComplianceCard = ({ data, colours, FONT }) => {
    // Utility function to calculate the percentage
    const getCompliancePercentage = (trackerType) => {
        if (!data.trackerhits) return 0;
        const trackerData = data.trackerhits.find((z) => z.tracker === trackerType);

        if (!trackerData) return 0;
        let result = roundNumberHelper((trackerData.hits / data.VShits.n) * 100)
        if(result > 100) {
            result = 100;
        }
        return result.toFixed(0);
    };

    return (
        <Paper
            sx={{ display: "flex", flexDirection: "column", width: { xs: '100%', sm: '50%' }, borderRadius: 2.5, padding: 3, boxSizing: "border-box" }}
        >
            <CardHeaderTitle
                title="Compliance"
                tooltip="Company Introduction and Recording Disclosures are key components of the Vocalysd Score, given an agent's minimum disclosure requirements. These metrics are determined by the detection of trackers in each conversation. A higher % indicates better adherence to standards."
                viewDetailTitle="View Details"
                viewDetailAction={() => console.log('show some data')}
            />

            <Grid
                container
                spacing={0}
                direction="row"
                gap={3}
                marginTop={2}
            >
                <Grid item xs>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>Intro Company</div>
                    <Typography variant="h5" component="div" fontWeight={600}>
                        {getCompliancePercentage("introcompany-detect")}%
                    </Typography>
                    <IncreaseDecreaseArrows increase={true} percentage="4%" />
                </Grid>
                <Grid item xs>
                    <div style={{ fontSize: FONT.SIZE_12, color: colours.grayDark }}>Recording Disclosed</div>
                    <Typography variant="h5" component="div" fontWeight={600}>
                        {getCompliancePercentage("recording-disclosure-detect")}%
                    </Typography>
                    <IncreaseDecreaseArrows increase={false} percentage="12%" />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default ComplianceCard;